document.documentElement.classList.add('js');
document.addEventListener('click', (event) => {
  const open = event.target.closest('[data-open-menu]');
  const close = event.target.closest('[data-close-menu]');
  const menu = document.getElementById('site-menu');
  if (open && menu) { menu.showModal(); open.setAttribute('aria-expanded', 'true'); }
  if (close && menu) menu.close();
});
document.addEventListener('close', (event) => {
  if (event.target.id === 'site-menu') document.querySelector('[data-open-menu]')?.setAttribute('aria-expanded', 'false');
}, true);
const feedObservers = new WeakMap();
function prepareFeeds(root = document) {
  root.querySelectorAll('.editorial-feed').forEach(feed => {
    if (feedObservers.has(feed)) return;
    const layout = () => {
      const mobile = matchMedia('(max-width:749px)').matches;
      feed.classList.toggle('is-paired', mobile);
      if (!mobile) return;
      const cards = [...feed.querySelectorAll('.editorial-card')];
      const width = feed.clientWidth;
      const gap = parseFloat(getComputedStyle(feed).columnGap) || 6;
      const ratio = card => Number(card.dataset.imageRatio) || (card.classList.contains('ratio-landscape') ? 1.25 : card.classList.contains('ratio-square') ? 1 : .8);
      for (let i = 0; i < cards.length; i += 2) {
        const pair = cards.slice(i, i + 2);
        const total = pair.reduce((sum, card) => sum + ratio(card), 0);
        const height = pair.length === 2 ? (width - gap) / total : Math.min(260, width / total);
        pair.forEach(card => {card.style.setProperty('--mobile-width', (height * ratio(card)) + 'px'); card.style.setProperty('--mobile-height', height + 'px');});
      }
    };
    const observer = new ResizeObserver(layout);observer.observe(feed);feedObservers.set(feed, observer);layout();
  });
}
prepareFeeds();
document.addEventListener('shopify:section:load', e => prepareFeeds(e.target));
document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('.editorial-feed').forEach(feed => feedObservers.get(feed)?.disconnect()));
// Enhance the native collection form as a panel; the form still works without JavaScript.
function prepareFilters(root=document){
 root.querySelectorAll('form.filters').forEach(form=>{
  if(form.dataset.panelReady)return;form.dataset.panelReady='true';
  const wrapper=document.createElement('div');wrapper.className='refine-bar';
  const open=document.createElement('button');open.type='button';open.textContent=form.dataset.refineLabel;open.setAttribute('aria-haspopup','dialog');
  const panel=document.createElement('dialog');panel.className='filter-drawer';panel.setAttribute('aria-label',form.dataset.refineLabel);
  const close=document.createElement('button');close.type='button';close.className='panel-close';close.textContent=form.dataset.closeLabel+' ×';
  form.before(wrapper);wrapper.append(open,panel);panel.append(close,form);
  open.addEventListener('click',()=>{panel.showModal();document.documentElement.classList.add('filter-open');});
  close.addEventListener('click',()=>panel.close());panel.addEventListener('close',()=>{form.reset();document.documentElement.classList.remove('filter-open');open.focus();});
 });
}
prepareFilters();document.addEventListener('shopify:section:load',e=>prepareFilters(e.target));

// One merchant-editable palette source feeds both product panels and listing counts.
window.tifPrepareColours = function(root=document){
 const registry=document.getElementById('tif-colour-families');
 if(!registry)return;
 const families=[...registry.content.querySelectorAll('[data-colour-family]')];
 const find=id=>families.find(f=>[...f.querySelectorAll('[data-product-id]')].some(a=>a.dataset.productId===id));
 root.querySelectorAll('[data-card-colours]').forEach(node=>{
  const family=find(node.dataset.cardColours);
  const native=Number(node.dataset.nativeCount);
  const count=native>1 ? native : family?.querySelectorAll('a').length || native;
  node.replaceChildren();
  if(count>1){const label=document.createElement('span');label.className='card-colour-count';label.textContent=registry.dataset.countFormat.replace('__COUNT__',count);node.append(' · ',label);}
 });
 root.querySelectorAll('.product-experience').forEach(experience=>{
  experience.querySelector('[data-shared-palette]')?.remove();
  if(Number(experience.dataset.nativeColourCount)>1)return; // Consolidated Shopify variants are authoritative.
  if(experience.querySelector('.colour-siblings'))return; // Explicit product metafields take priority.
  const family=find(experience.dataset.productId);if(!family)return;
  const links=[...family.querySelectorAll('a')];if(links.length<2)return;
  const selected=links.find(a=>a.dataset.productId===experience.dataset.productId);
  const palette=document.createElement('div');palette.className='colour-siblings';palette.dataset.sharedPalette='';
  const title=document.createElement('p'),current=document.createElement('span');current.dataset.currentColour=selected.dataset.colourLabel;current.textContent=selected.dataset.colourLabel;title.append(registry.dataset.colourLabel+': ',current);
  const options=document.createElement('div');options.className='option-values';
  links.forEach(link=>{const copy=link.cloneNode(true);if(copy.dataset.productId===experience.dataset.productId)copy.setAttribute('aria-current','true');options.append(copy);});
  palette.append(title,options);experience.querySelector('.product-intro').after(palette);
 });
};
window.tifPrepareColours();
document.addEventListener('shopify:section:load',()=>{window.tifPrepareColours();document.dispatchEvent(new CustomEvent('tif:catalog-updated'));});
document.addEventListener('shopify:section:unload',()=>{setTimeout(()=>{window.tifPrepareColours();document.dispatchEvent(new CustomEvent('tif:catalog-updated'));},0);});
document.addEventListener('shopify:block:select',event=>{
 const details=event.target.closest('.editor-catalog-guide details');if(details)details.open=true;
 event.target.querySelector('.editorial-card')?.scrollIntoView({behavior:'smooth',block:'center'});
});

// Recalculate mobile image pairs after the automatic home feed is assembled.
document.addEventListener('tif:home-updated', event => {
  const feed=event.detail.feed;
  feedObservers.get(feed)?.disconnect();
  feedObservers.delete(feed);
  prepareFeeds(feed.parentElement);
});
